import React, { useEffect, useState } from 'react';
import { every } from 'lodash';
import { FormSelect, ModalPattern } from '../../../../../components';
import { FormInputWithTitle } from '../../../../../components';
import { useGetFriedMaterials } from '../../../../../api/dictionary';
import { workCenterOptions } from '../../../../../constants/catering.constants';

export const ModalAddMaterial = ({ onCancel, onConfirm, loading }) => {
  const { data: materials = [] } = useGetFriedMaterials();

  const [modalData, setModalData] = useState({
    materialId: null,
    workCenter: null,
    batchSize: null,
    unit: null,
  });

  const units = materials.find(m => m.materialCode === modalData.materialId)?.measurementUnits || [];

  const handleChange = (name, value) => setModalData(prev => ({ ...prev, [name]: value }));

  useEffect(() => {
    handleChange('unit', units[0]?.name);
  }, [modalData.materialId]);

  return (
    <ModalPattern
      size="sm"
      title="Add Material"
      loading={loading}
      confirmDisabled={loading || !every(modalData, Boolean)}
      onCancel={onCancel}
      onConfirm={() => {
        onConfirm(modalData);
      }}
      modalBody={
        <div className="d-flex flex-column gap-3">
          <FormSelect
            title="Material Type"
            name="materialId"
            options={materials.map(m => ({ label: m.name, value: m.materialCode }))}
            value={modalData.materialId}
            onChange={handleChange}
          />
          <div className="d-flex justify-content-between gap-3">
            <div className="w-100">
              <FormInputWithTitle
                type="number"
                placeholder="Batch Size"
                name="batchSize"
                value={modalData.batchSize}
                onChange={handleChange}
              />
            </div>
            <div className="w-100">
              <FormSelect
                title="Unit"
                name="unit"
                options={units.map(u => ({ label: u.name, value: u.name }))}
                value={modalData.unit}
                onChange={handleChange}
              />
            </div>
          </div>
          <FormSelect
            title="Work Center"
            name="workCenter"
            options={workCenterOptions}
            value={modalData.workCenter}
            onChange={handleChange}
          />
        </div>
      }
      confirmText="Save"
    />
  );
};
